import styled from "styled-components/macro";

export default styled.div`
position: fixed;
  top: 0;
  z-index: 9;
  width: 100%;
`;
